:host {
    display: block;
    position: relative; // This is needed for IE11

    * {
        box-sizing: border-box;
    }

    .ti-sticky-header-wrapper {
        width: 100%;

        .ti-sticky-header-content {
            width: 100%;
            background: $pl-container-background-color-primary;
            display: flex;
            flex-direction: column;

            &.ti-sticky-header-sticky {
                position: fixed;
                z-index: 200;
                top: 0;
                left: 0;
                box-shadow: $polaris-boxShadow-4;
                animation: $polaris-animation-timing-enter $polaris-animation-easing-decelerate reveal-from-top forwards;
            }

            .ti-sticky-header-top {
                overflow: visible;
                transition: height .3s;
            }
        }
    }
}

:host(.ti-sticky-header-desktop) {
    .ti-sticky-header-wrapper {
        margin: -8px 0; // workaround for flexbox increasing size
    }
}

@keyframes reveal-from-top {
    from {transform: translateY(-100%);}
    to {transform: translateY(0);}
}
